import { render, staticRenderFns } from "./signin.vue?vue&type=template&id=2bbfea20"
import script from "./signin.vue?vue&type=script&lang=js"
export * from "./signin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports